/** Class keys used to identify markup components */
var ACCORDION_BLOCK = '.accordion';
var ACCORDION_CONTAINER = '.accordion-item';
var ACCORDION_BUTTON = '.cta-button';
var ACCORDION_CONTENT = '.accordion-item-dropdown';
var ACTIVE_CONTENT_CLASS = 'state-active';
var INACTIVE_BUTTON_CLASS = 'state-active';

/**
 * Tracks a single accordion
 * <p>
 * Notice that 'activating' a single block simply applies the 'state-active'
 * class to it, and removes it from the existing active block. Use CSS
 * transitions to handle animations to and from this state.
 */
var Accordian = function () {
  this.elements = [];
  this.active = null;
  return this;
};

/** Bind the accordian tracker to a particular container */
Accordian.prototype.bind = function ($target) {
  var self = this;
  $target.find(ACCORDION_CONTAINER).each(function (i, container) {
    var $container = $(container);
    var item = {
      $button: $container.find(ACCORDION_BUTTON),
      $content: $container.find(ACCORDION_CONTENT)
    };
    item.$button.click(function () {
      self.toggle(item);
      return false;
    });
    self.elements.push(item);
  });
};

/** Toggle the active state */
Accordian.prototype.toggle = function (item) {
  var previous = this.active;
  if (previous !== null) {
    previous.$button.removeClass(INACTIVE_BUTTON_CLASS);
    previous.$content.removeClass(ACTIVE_CONTENT_CLASS);
    var inactive_state = previous.$button.attr('data-inactive');
    if (inactive_state) {
      previous.$button.text(inactive_state);
    }
    this.active = null;
  }
  if (previous != item) {
    item.$button.addClass(INACTIVE_BUTTON_CLASS);
    item.$content.addClass(ACTIVE_CONTENT_CLASS);
    var active_state = item.$button.attr('data-active');
    if (active_state) {
      item.$button.text(active_state);
    }
    this.active = item;
    this.scrollToActive();
  }
};

/** Scroll to the next item */
Accordian.prototype.scrollToActive = function () {
  if ((this.active) && (this.active.$button)) {
    $('html, body').animate({
      scrollTop: $(this.active.$button).offset().top
    }, 300);
  }
};

/** Tracks all accordians */
var AccordionController = function () {
  this.widgets = [];
  return this;
};

/** Find any accordian objects and bind events to them */
AccordionController.prototype.apply = function () {
  var self = this;
  $(ACCORDION_BLOCK).each(function (i, block) {
    var accordion = new Accordian();
    accordion.bind($(block));
    self.widgets.push(accordion);
  });
};

export default AccordionController;